export default __webpack_public_path__ + "static/media/navratri_12_59.4a9e6cc8.gif";